(function () {
  const syncNav = () => {
    const nav = document.querySelector('.tincy-primary-nav');
    const pageScroller = document.querySelector('.page-wrapper');
    if (!nav || !document.body.classList.contains('tincy-template-index')) return;

    const scrollTop = Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0,
      pageScroller ? pageScroller.scrollTop : 0
    );
    const isScrolled = scrollTop > 64;

    document.body.classList.toggle('tincy-nav-scrolled', isScrolled);
    nav.style.setProperty('position', 'fixed', 'important');
    nav.style.setProperty('top', '0', 'important');
    nav.style.setProperty('left', '0', 'important');
    nav.style.setProperty('right', '0', 'important');
    nav.style.setProperty('z-index', '1200', 'important');
    nav.style.setProperty('min-height', '74px', 'important');
    nav.style.setProperty('background', isScrolled ? '#070303' : 'rgba(7, 3, 3, 0.58)', 'important');
    nav.style.setProperty('border-bottom', isScrolled ? '1px solid rgba(255, 243, 238, 0.12)' : '1px solid rgba(255, 243, 238, 0.08)', 'important');
    nav.style.setProperty('box-shadow', isScrolled ? '0 14px 32px rgba(0, 0, 0, 0.26)' : '0 8px 22px rgba(0, 0, 0, 0.16)', 'important');
    nav.style.setProperty('backdrop-filter', 'blur(12px)', 'important');
  };

  const ready = () => {
    syncNav();
    [80, 250, 700, 1400, 2600, 5000].forEach((delay) => window.setTimeout(syncNav, delay));
    window.addEventListener('scroll', syncNav, { passive: true });
    document.addEventListener('scroll', syncNav, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', syncNav, { passive: true });

    const nav = document.querySelector('.tincy-primary-nav');
    if (!nav) return;
    let guardRunning = false;
    new MutationObserver(() => {
      if (guardRunning) return;
      guardRunning = true;
      window.requestAnimationFrame(() => {
        syncNav();
        guardRunning = false;
      });
    }).observe(nav, { attributes: true, attributeFilter: ['style'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
